module.exports = __webpack_public_path__ + "static/media/Subtract03.2efa5457.svg";